import moment from "moment";

export default (time, format = 'dddd, MMMM Do YYYY, h:mm:ss a') => {
    return moment(time).format(format);
};


// WEBPACK FOOTER //
// ./src/helpers/time/timeHuman.js